/* Dorabella – "+" sulle card: pannello rapido stile Zara (colore + taglia, un tocco e va nel carrello). 28/09/2026 */
(function () {
  var sheet, cache = {}, busy = false;

  function money(c) { return '€' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function optIndex(p, re) { for (var i = 0; i < p.options.length; i++) { if (re.test(String(p.options[i].name || p.options[i]).toLowerCase())) return i; } return -1; }
  function img(src, w) { if (!src) return ''; return src.replace(/(\.[a-z]+)(\?.*)?$/i, function (m, ext, q) { return ext + (q ? q + '&' : '?') + 'width=' + w; }); }

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'dora-qs';
    sheet.setAttribute('hidden', '');
    sheet.innerHTML =
      '<div class="dora-qs__bg" data-qs-close></div>' +
      '<div class="dora-qs__panel" role="dialog" aria-modal="true" aria-label="Scegli colore e taglia">' +
      '<button type="button" class="dora-qs__x" data-qs-close aria-label="Chiudi">×</button>' +
      '<div class="dora-qs__body"></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', onSheetClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hasAttribute('hidden')) close(); });
  }

  function open(handle, preColor, url) {
    if (!sheet) build();
    var body = sheet.querySelector('.dora-qs__body');
    body.innerHTML = '<div class="dora-qs__loading"></div>';
    sheet.removeAttribute('hidden');
    document.documentElement.classList.add('dora-qs-open');
    setTimeout(function () { sheet.classList.add('is-open'); }, 20);
    var p = cache[handle] ? Promise.resolve(cache[handle]) : fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); });
    p.then(function (prod) {
      cache[handle] = prod;
      sheet._p = prod; sheet._url = url || prod.url;
      var ci = optIndex(prod, /colou?r|colore/);
      var colors = [];
      if (ci > -1) prod.variants.forEach(function (v) { var c = v.options[ci]; if (v.available && colors.indexOf(c) < 0) colors.push(c); });
      if (!colors.length && ci > -1) { close(); location.href = sheet._url; return; }
      var sel = colors.indexOf(preColor) > -1 ? preColor : colors[0];
      sheet._ci = ci; sheet._color = sel;
      render();
    }).catch(function () { close(); if (url) location.href = url; });
  }

  function render() {
    var p = sheet._p, ci = sheet._ci, color = sheet._color;
    var si = optIndex(p, /taglia|size|misura/);
    var vs = p.variants.filter(function (v) { return v.available && (ci < 0 || v.options[ci] === color); });
    var first = vs[0] || p.variants[0];
    var src = (first.featured_image && first.featured_image.src) || p.featured_image;
    var pct = first.compare_at_price > first.price ? Math.round((first.compare_at_price - first.price) * 100 / first.compare_at_price) : 0;
    var ms = window.DoraMySize, pref = ms && ms.get ? ms.get() : null;
    var curvy = (p.tags || []).join(',').toLowerCase().indexOf('curvy') > -1;

    var h = '<div class="dora-qs__head">' +
      (src ? '<img class="dora-qs__img" src="' + esc(img(src, 200)) + '" alt="" width="64" height="85">' : '') +
      '<div class="dora-qs__info"><div class="dora-qs__title">' + esc(p.title) + '</div>' +
      '<div class="dora-qs__price"><b>' + money(first.price) + '</b>' +
      (pct ? ' <s>' + money(first.compare_at_price) + '</s> <span class="dora-qs__disc">-' + pct + '%</span>' : '') + '</div>' +
      '<a class="dora-qs__more" href="' + esc(sheet._url) + '">Vedi dettagli</a></div></div>';

    if (ci > -1) {
      var colors = [];
      p.variants.forEach(function (v) { var c = v.options[ci]; if (v.available && colors.indexOf(c) < 0) colors.push(c); });
      h += '<div class="dora-qs__label">Colore: <b>' + esc(color) + '</b></div><div class="dora-qs__colors">';
      colors.forEach(function (c) {
        var v = p.variants.find(function (x) { return x.options[ci] === c && x.featured_image; });
        var th = v ? img(v.featured_image.src, 80) : '';
        h += '<button type="button" class="dora-qs__color' + (c === color ? ' is-on' : '') + '" data-qs-color="' + esc(c) + '" aria-label="' + esc(c) + '">' +
          (th ? '<img src="' + esc(th) + '" alt="" loading="lazy">' : '<span>' + esc(c.slice(0, 2)) + '</span>') + '</button>';
      });
      h += '</div>';
    }

    var solo = vs.length === 1;
    h += '<div class="dora-qs__label"' + (solo && si < 0 ? ' hidden' : '') + '>' + (si > -1 ? (solo ? 'Taglia' : 'Scegli la taglia') : 'Aggiungi al carrello') +
      (pref && pref.label ? ' <span class="dora-qs__mine">La tua: ' + esc(pref.label) + '</span>' : '') + '</div><div class="dora-qs__sizes">';
    vs.forEach(function (v) {
      var label = si > -1 ? v.options[si] : (vs.length > 1 ? v.title : 'Aggiungi al carrello');
      var mine = si > -1 && pref && ms.matches(label, pref, curvy);
      if (solo) {
        h += '<button type="button" class="dora-qs__size dora-qs__size--cta" data-qs-add="' + v.id + '">' +
          (si > -1 ? '<span>Aggiungi al carrello</span><small>' + esc(label) + '</small>' : '<span>' + esc(label) + '</span>') + '</button>';
        return;
      }
      h += '<button type="button" class="dora-qs__size' + (mine ? ' is-mine' : '') + '" data-qs-add="' + v.id + '">' + esc(label) + '</button>';
    });
    h += '</div><div class="dora-qs__msg" aria-live="polite"></div>';
    sheet.querySelector('.dora-qs__body').innerHTML = h;
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('dora-qs-open');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.setAttribute('hidden', ''); }, 250);
  }

  function onSheetClick(e) {
    if (e.target.closest('[data-qs-close]')) { close(); return; }
    var c = e.target.closest('[data-qs-color]');
    if (c) { sheet._color = c.getAttribute('data-qs-color'); render(); return; }
    var b = e.target.closest('[data-qs-add]');
    if (!b || busy) return;
    busy = true; b.classList.add('is-loading');
    var msg = sheet.querySelector('.dora-qs__msg');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-qs-add')), quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (msg) msg.textContent = res.description || 'Taglia non più disponibile'; return; }
        close();
        return (window.doraRefreshDrawer ? window.doraRefreshDrawer() : Promise.resolve()).then(function () {
          var d = document.querySelector('cart-drawer'); if (d && typeof d.open === 'function') d.open();
          document.dispatchEvent(new CustomEvent('cartUpdated'));
        });
      })
      .catch(function () { if (msg) msg.textContent = 'Riprova tra un attimo'; })
      .then(function () { busy = false; b.classList.remove('is-loading'); });
  }

  // Intercetta il "+" di tutte le card prodotto (prima degli altri gestori)
  function onPlus(e) {
    var qv = e.target.closest && e.target.closest('.card-product .quick-add quick-view');
    if (!qv) return;
    var handle = qv.getAttribute('data-product-handle');
    if (!handle) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var card = qv.closest('.card-product');
    var on = card && card.querySelector('.swatch-button.active');
    var onName = on ? (on.getAttribute('aria-label') || (on.querySelector('.sr-only') || {}).textContent || '').trim() : null;
    var link = card && card.querySelector('a.product-link');
    open(handle, onName, link ? link.getAttribute('href') : null);
  }
  window.addEventListener('click', onPlus, true);
  window.addEventListener('keydown', function (e) { if (e.key === 'Enter') onPlus(e); }, true);
})();
